export default __webpack_public_path__ + "static/media/the-commons.cb96e893.jpg";